import { DataTable } from '../../../models';
import { DateWindowFunction, DateWindowTypes } from '../core';
import { trimMetricTable } from '../trimMetricTable';

export interface LastNDateWindow {
  n: number;
  type: DateWindowTypes.LAST_N;
}

export const lastNDateWindow = (numberOfPoints: number): DateWindowFunction => {
  return (table: DataTable) => trimMetricTable(table, numberOfPoints);
};

export const createLastNWindow = (n: number): LastNDateWindow => {
  return {
    type: DateWindowTypes.LAST_N,
    n,
  };
};
